import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "goodmax-theme";

function getInitialTheme() {
    if (typeof window === "undefined") return "dark";
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
    return "dark"; // default
}

export function useTheme() {
    const [theme, setThemeState] = useState(getInitialTheme);

    useEffect(() => {
        const root = document.documentElement;
        if (theme === "dark") root.classList.add("dark");
        else root.classList.remove("dark");
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        } catch {
            // ignore
        }
    }, [theme]);

    const toggle = useCallback(() => {
        setThemeState((t) => (t === "dark" ? "light" : "dark"));
    }, []);

    return { theme, toggle, setTheme: setThemeState };
}
